<template>
  <div class="page-import">
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>导入记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="importRecordTable">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleClick" style="padding-left:10px;">
          <el-tab-pane label="简历导入记录" name="first" :disabled="listLoading"></el-tab-pane>
          <el-tab-pane label="流程导入记录" name="second" :disabled="listLoading"></el-tab-pane>
          <el-tab-pane label="入职导入记录" name="third" :disabled="listLoading"></el-tab-pane>
          <el-tab-pane label="离职导入记录" name="four" :disabled="listLoading"></el-tab-pane>
        </el-tabs>
        <el-tabs v-if="activeTab == 'second'" v-model="batchTab" @tab-click="handleBatchClick" style="padding-left:10px;">
          <el-tab-pane label="批量待面试" name="first" :disabled="listLoading"></el-tab-pane>
          <el-tab-pane label="批量待入职" name="second" :disabled="listLoading"></el-tab-pane>
        </el-tabs>
        <el-table :data="tableData" class="re_table" :max-height="tableHeight-180" v-loading="listLoading">
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="{$index}">
              <span>{{(Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="activeTab != 'first'" align="center" label="项目名称" prop="StrprojectName" min-width="110px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column v-if="activeTab != 'first'" align="center" label="岗位名称" prop="CustomerJobName" min-width="110px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column v-if="activeTab == 'third'" align="center" label="入职类型" prop="StrOperType" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column v-if="activeTab == 'first'" align="center" label="导入名称" prop="StrCustName" min-width="110px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="操作时间" prop="opTime" min-width="120px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="操作人员" prop="Username" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column v-if="activeTab == 'first'" align="center" label="导入进度" width="135px">
            <template slot-scope="scope">
              <div>
                <el-steps :active="scope.row.StrImpEdateStr * 0.05" :process-status="(scope.row.StrErrorLine == '0') ? 'success' : 'error' " align-center :space="50">
                  <el-step title="解析"
                    status="success">
                  </el-step>
                  <el-step title="完成"
                    :status="(scope.row.StrErrorLine=='0')&&(Number(scope.row.StrRightLine) > 0) ? 'success' : 'error' ">
                  </el-step>
                </el-steps>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="activeTab != 'first'" align="center" label="导入进度" width="250px">
            <template slot-scope="scope">
              <div>
                <el-steps
                  :active="scope.row.StrImpEdateStr * 0.05"
                  :process-status="
                    scope.row.StrImpEdateStr == '100' ? 'success' : 'error'
                  "
                  align-center
                  :space="50"
                >
                  <el-step
                    title="解析"
                    :status="
                      scope.row.StrImpEdateStr == '20' ||
                      scope.row.StrImpEdateStr == '40' ||
                      scope.row.StrImpEdateStr == '60' ||
                      scope.row.StrImpEdateStr == '80' ||
                      scope.row.StrImpEdateStr == '100'
                        ? 'success'
                        : new Date().getTime() >
                            new Date(
                              new Date(scope.row.opTime).valueOf() + 360000
                            ).getTime() ||
                          (scope.row.StrImpEdateStr != '0' &&
                            scope.row.StrImpEdateStr != '20' &&
                            scope.row.StrImpEdateStr != '40' &&
                            scope.row.StrImpEdateStr != '60' &&
                            scope.row.StrImpEdateStr != '80' &&
                            scope.row.StrImpEdateStr != '100' &&
                            scope.row.StrImpEdateStr != null)
                        ? 'error'
                        : 'wait'
                    "
                  >
                  </el-step>
                  <el-step
                    title="导入"
                    :status="
                      scope.row.StrImpEdateStr == '40' ||
                      scope.row.StrImpEdateStr == '60' ||
                      scope.row.StrImpEdateStr == '80' ||
                      scope.row.StrImpEdateStr == '100'
                        ? 'success'
                        : new Date().getTime() >
                            new Date(
                              new Date(scope.row.opTime).valueOf() + 360000
                            ).getTime() ||
                          (scope.row.StrImpEdateStr != '0' &&
                            scope.row.StrImpEdateStr != '20' &&
                            scope.row.StrImpEdateStr != '40' &&
                            scope.row.StrImpEdateStr != '60' &&
                            scope.row.StrImpEdateStr != '80' &&
                            scope.row.StrImpEdateStr != '100' &&
                            scope.row.StrImpEdateStr != null)
                        ? 'error'
                        : 'wait'
                    "
                  >
                  </el-step>
                  <el-step
                    title="勘误"
                    :status="
                      scope.row.StrImpEdateStr == '60' ||
                      scope.row.StrImpEdateStr == '80' ||
                      scope.row.StrImpEdateStr == '100'
                        ? 'success'
                        : new Date().getTime() >
                            new Date(
                              new Date(scope.row.opTime).valueOf() + 360000
                            ).getTime() ||
                          (scope.row.StrImpEdateStr != '0' &&
                            scope.row.StrImpEdateStr != '20' &&
                            scope.row.StrImpEdateStr != '40' &&
                            scope.row.StrImpEdateStr != '60' &&
                            scope.row.StrImpEdateStr != '80' &&
                            scope.row.StrImpEdateStr != '100' &&
                            scope.row.StrImpEdateStr != null)
                        ? 'error'
                        : 'wait'
                    "
                  >
                  </el-step>
                  <el-step
                    title="入库"
                    :status="
                      scope.row.StrImpEdateStr == '80' ||
                      scope.row.StrImpEdateStr == '100'
                        ? 'success'
                        : new Date().getTime() >
                            new Date(
                              new Date(scope.row.opTime).valueOf() + 360000
                            ).getTime() ||
                          (scope.row.StrImpEdateStr != '0' &&
                            scope.row.StrImpEdateStr != '20' &&
                            scope.row.StrImpEdateStr != '40' &&
                            scope.row.StrImpEdateStr != '60' &&
                            scope.row.StrImpEdateStr != '80' &&
                            scope.row.StrImpEdateStr != '100' &&
                            scope.row.StrImpEdateStr != null)
                        ? 'error'
                        : 'wait'
                    "
                  >
                  </el-step>
                  <el-step
                    title="完成"
                    :status="
                      scope.row.StrImpEdateStr == '100'
                        ? 'success'
                        : new Date().getTime() >
                            new Date(
                              new Date(scope.row.opTime).valueOf() + 360000
                            ).getTime() ||
                          (scope.row.StrImpEdateStr != '0' &&
                            scope.row.StrImpEdateStr != '20' &&
                            scope.row.StrImpEdateStr != '40' &&
                            scope.row.StrImpEdateStr != '60' &&
                            scope.row.StrImpEdateStr != '80' &&
                            scope.row.StrImpEdateStr != '100' &&
                            scope.row.StrImpEdateStr != null)
                        ? 'error'
                        : 'wait'
                    "
                  >
                  </el-step>
                </el-steps>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="导入结果" min-width="170px" fit :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.StrErrmess}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="成功条数" prop="StrRightLine" min-width="80px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="错误条数" prop="StrErrorLine" min-width="80px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="导入状态" prop="StrErrorLine" min-width="90px">
            <template slot-scope="scope">
              <!-- <div v-show="(scope.row.StrImpEdateStr == '100')&& Number(scope.row.StrErrorLine) > 0" title="点击可查看错误条数" class="errorLi" @click="jumpHandle(scope.row.StrExcelPath)">
                <img src="./../../../assets/employee/images/warning.png" alt='' style="width: 24px" />
                <span style="margin-left: 10px">{{
                  scope.row.StrErrorLine
                }}</span>
              </div> -->
              <div v-if="(scope.row.StrErrorLine == '0')&&(Number(scope.row.StrRightLine) > 0)">
                <img src="./../../../assets/employee/images/success.png" style="width: 24px">
              </div>
              <el-tooltip v-else effect="dark"
                content="查看错误记录"
                placement="top">
                <el-button type="warning" size="mini" icon="el-icon-message" style="cursor: pointer;" circle @click="jumpHandle(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-show="totalnum > 0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="infoQuery.currpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total,sizes,prev,pager, next, jumper" :total="this.totalnum"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import xz from "./../../../common";
import checkPermission from "@/utils/permission"; // 权限判断函数
// import ResourceComTabs from "./resourceComTabs.vue"
// import FUN from "./../../../fun";
export default {
  name: "resImportRecord",
  components: {
    // ResourceComTabs
  },
  data() {
    return {
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight: 0,
      activeTab:'first',
      batchTab:'first',
      //表头错误提示
      isError: false,
      errorTxt: '',
      min: 1,
      rowinfo: '',
      listLoading: false,
      dialogVisible: false,
      totalnum: null,
      //勘误后导入
      ExcelSrc: {
        value: '',
        check: false,
        fileName: '',
        oldexcelpath: ''
      },
      //导入到的项目名称
      exportName: '',
      //导入步骤
      active: 0,
      //是否覆盖
      isReset: false,
      //文件是否已上传
      isFileSuccess: false,
      //导入成功
      dialogVisible6: false,
      //导入的条数
      totalmain: '',
      excelpath: '',
      reimp: 0,
      reimpLab: "0",
      infoPath: '',
      entid: '',
      instname: '',
      StrUserName: '',
      StrSrvCent: '',
      StrObjName: '',
      tabId: '',
      fullscreenLoading: false,
      //已选择的下级
      selectedSubordinate: null,
      //下拉筛选
      showDropScreen: -1,
      currentPage3: 1,
      tableData: [],
      pageSize: 10,
      //数据参数
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        strOperType:'',//待面试批量导入 待入职批量导入 入职批量导入  离职批量导入
        excelname: '',
        tableid: "JB_busi_PsnBaseImp",
        datestart: '',
        dateend: '',
        strobjname:'',
        impdate: '',
        druserId: ''
      },
      //上传excel是否成功-判断下一步按钮是否禁用
      isUploadSuccess: true,
      // 定时器
      timer: null,
      //现在时间
      nowDate: '',
      //旧的excel地址
      oldexcelpath: '',
      //是否全都成功导入
      isEverySuccess: [],
      // 导入时对应的StrTableId
      exportTableId: '',
      userid: '',
      //角色类型
      roleType: '',
      activeName: '导入导出记录',
      tabids: [],
      // 权限参数
      importProjectList:[]
    }
  },
  created() {
    if(!this.isNull(this.$route.query.active)){
      this.activeName = this.$route.query.active
    }else{
      this.activeName = '导入导出记录'
    }
    if(!this.isNull(this.$route.query.activeTab)){//判断从哪个页面过来
      this.activeTab = this.$route.query.activeTab
      if(this.activeTab == 'first'){
        this.infoQuery.tableid = 'JB_busi_PsnBaseImp'
        this.infoQuery.strOperType = ''
      }else if(this.activeTab == 'second'){
        this.infoQuery.tableid = 'JB_emp_PsnStatusDms'
        this.infoQuery.strOperType = '待面试批量导入'
      }else if(this.activeTab == 'third'){
        this.infoQuery.tableid = 'JB_emp_UserBaseSimple,JB_emp_UserBaseMainte,JB_emp_UserBase'
        this.infoQuery.strOperType = '入职批量导入'
      }else if(this.activeTab == 'four'){
        this.infoQuery.tableid = 'JB_emp_UserBaseDepart'
        this.infoQuery.strOperType = '离职批量导入'
      }
    }else{
      this.infoQuery.tableid = 'JB_busi_PsnBaseImp'
    }
    this.roleType = localStorage.loginRoletype
    this.getImportProject()
    this.calHeight();
    this.nowDate = new Date()
    this.getOpeRecord(this.infoQuery);
    this.dataRefreh();
    this.userid = Cookies.get('userid-b');
  },
  methods: {
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
    //   console.log('height', this.tableHeight)
    },
    // 查询是否有导入权限--获取项目列表
    getImportProject(){
      xz.getProjectImpSet({roletype:this.roleType}).then(res => {
        if (res.status == 'ok') {
          // console.log(99,res)
          this.importProjectList = res.msg.data
        }
      })
    },
    handleClick(tab){
      this.activeTab = tab.name
      this.infoQuery.currpage = 1
      if(tab.name == 'first'){
        this.infoQuery.tableid = 'JB_busi_PsnBaseImp'
        this.infoQuery.strOperType = ''
      }else if(tab.name == 'second'){
        this.infoQuery.tableid = 'JB_emp_PsnStatusDms'
        this.infoQuery.strOperType = '待面试批量导入'
      }else if(tab.name == 'third'){
        this.infoQuery.tableid = 'JB_emp_UserBaseSimple,JB_emp_UserBaseMainte,JB_emp_UserBase'
        this.infoQuery.strOperType = '入职批量导入'
      }else if(tab.name == 'four'){
        this.infoQuery.tableid = 'JB_emp_UserBaseDepart'
        this.infoQuery.strOperType = '离职批量导入'
      }
      this.getOpeRecord(this.infoQuery);
    },
    handleBatchClick(tab){
      this.batchTab = tab.name
      this.infoQuery.currpage = 1
      if(tab.name == 'first'){
        this.infoQuery.tableid = 'JB_emp_PsnStatusDms'
        this.infoQuery.strOperType = '待面试批量导入'
      }else if(tab.name == 'second'){
        this.infoQuery.tableid = 'JB_emp_PsnStatusDrz'
        this.infoQuery.strOperType = '待入职批量导入'
      }
      this.getOpeRecord(this.infoQuery);
    },
    // 跳转错误详情页
    jumpHandle(val){
      // console.log('ll',val)
      this.$router.push({ path: 'importErrorList',
        query:{
          strExcelPath: val.StrExcelPath,
          strTableId: val.StrTableId+'err',
          activeTab: this.activeTab
        }
      })
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
    },
    isNullNotZero(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
    },
    // 清除定时器的代码
    clear() {
      clearInterval(this.timer)
      this.timer = null
    },
    download(row) {
    //   let url = 'http://emp.jobkeji.cn/cloudexcel/' + row.StrExcelPath;
      let url = location.origin + '/cloudexcel/' + row.StrExcelPath;
      const link = document.createElement('a');
      link.download = row.StrCustName;
      link.href = url;
      link.click();
    },
    // 定时刷新数据函数
    async dataRefreh() {
      let thats = this
      // 计时器正在进行中，退出函数
      if (this.timer != null) {
        return;
      }
      // //如果返回的数据有一个不成功就刷新 反之清除定时器
      // 计时器为空，操作
      this.timer = setInterval(() => {
        // console.log("刷新" + new Date());
        this.min++;
        let errcount = 0;
        for (let index = 0; index < this.tableData.length; index++) {
          const elementData = this.tableData[index];
          let itemDate = elementData.DtImpDate.replace('T',' ');
          // console.log('1111',itemDate)
          if (new Date().getTime() < new Date((new Date(itemDate)).valueOf() + 360000)) {
            // if (elementData.StrImpEdateStr == 0) {
            //   errcount = errcount + 1
            // }
            if(thats.activeTab == 'third'){//入职批量导入
              if ((thats.isNullNotZero(elementData.StrErrorLine)) || (elementData.StrImpEdateStr != '100')) {
                errcount = errcount + 1
              }
            }else{
              if ((thats.isNullNotZero(elementData.StrErrorLine)) || (thats.isNull(elementData.StrRightLine))) {
                errcount = errcount + 1
              }
            }
            // else if (elementData.StrImpEdateStr.length < 5) {
            //   errcount = errcount + 1
            // }
          }
        }
        // console.log('errcount',errcount)
        if (errcount > 0) {
          thats.getOpeRecord(thats.infoQuery);
        } else {
          clearInterval(this.timer);
        }
      }, 20000);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currpage = Number(val);
      this.infoQuery.currpage = Number(val);
      this.getOpeRecord(this.infoQuery);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.infoQuery.pagecount = Number(val);
      this.pageSize = parseInt(val);
      this.getOpeRecord(this.infoQuery);
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1
      }
    },
    getOpeRecord(data) {
      this.infoQuery = data;
      this.$store.commit("getLeftNum");
      this.listLoading = true
      xz.getPsnImpDataList(data).then(res => {
        // console.log('ss', res)
        if (res.msg && res.msg.data.length > 0) {
          res.msg.data.forEach(l => {
            var opTime = l.DtImpDate.replace('T',' ');
            l['opTime'] = opTime;
          })
          this.tableData = res.msg.data
          this.totalnum = parseInt(res.msg.totalnum);
        } else {
          this.totalnum = 0
          this.tableData = []
        }
        this.listLoading = false
      })
    },
    //下载模板
    downLoadHandle() {
      xz.getImportMode().then(res => {
        // console.log('下载模板', res)
        if (res) {
          var d = res.msg.data.StrOutPath
          d = d.replace("\"", "").replace("\"", "")
          var path = this.tablePath + d
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click()
        }
      })
    },
    // 下拉选择人员
    selectSubordinate(d) {
      this.userId = d.value;
      this.username = d.label;
      // console.log("d", d);
      this.selectedSubordinate = d.label;
    },
    // 下拉选择是否覆盖
    selectReimp(d) {
      if (d == true) {
        this.reimp = 1
        this.reimpLab = 1
      } else {
        this.reimp = 0
        this.reimpLab = 0
      }
      // console.log("d", d);
    },
    //查看详情
    showDetails(val) {
      // console.log('val',val.StrExcelPath)
      let path = val.StrExcelPath;
      let errorLength = val.errorlength
      this.$router.push({
        path: "/resImportDetails",
        query: {
          path,
          errorLength
        }
      })
    }
  },
  beforeDestroy() {
    // 在页面销毁后，清除计时器
    this.clear();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.re_table.el-table .el-table__cell{
  padding: 3px 0;
}
.page-import .el-tabs--top{
  background-color: #fff;
}
.p_roster_table.el-tabs--card {
    background-color: #fff;
}
.page-import .el-dialog .el-dialog__header {
  padding: 0;
}
.page-import .el-step__title {
  font-size: 13px;
  line-height: 24px;
}
.page-import .el-step__icon {
  width: 20px;
  height: 20px;
  font-size: 12px;
}
.page-import .dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.changeError {
  padding: 5px 10px;
  border: solid 1px red;
  font-size: 12px;
  color: red;
  border-radius: 4px;
  background-color: #fff;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}

.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .el-dialog .el-dialog__header {
  background: #fff;
}
</style>
<style scoped>
.result-box {
  padding: 15px 10px;
  border-radius: 5px;
  background-color: rgba(103, 194, 58, 0.1);
}
.file-box {
  position: relative;
}
.top-right {
  display: flex;
  align-items: center;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rIcon {
  font-size: 18px;
  color: #50d4ab;
}
</style>